import React, { useState, useContext, useEffect } from 'react'
import CloudformationOutputs from '../CloudformationOutputs.json'
import { GlobalContext } from '../GlobalContext'

type Props = {
  
}


function SingleSignOn({
}: Props) {

    const {
        t
    } = useContext(GlobalContext)


    const client_id = CloudformationOutputs['EntraClientId']
    const redirect_url_raw = CloudformationOutputs['EntraRedirectLambdaUrl']
    const redirect_url = encodeURIComponent(redirect_url_raw)
    const currentUrlOrigin = window.location.origin
    const entraUrl = `https://login.microsoftonline.com/common/oauth2/v2.0/authorize?client_id=${client_id}&response_type=code&redirect_uri=${redirect_url}&scope=openid%20profile%20email&state=${currentUrlOrigin}`

 


    return <div className={`w-full flex flex-col gap-2`}> 

        <a href={entraUrl} className={`w-full px-3 py-3 bg-white flex flex-row gap-4 items-center justify-center cursor-pointer hover:opacity-80 text-gray-800 border-gray-400 rounded`}>
            <img src={`/logos/microsoft.svg`} alt={`Microsoft logo`} className={`w-6 h-6`} />
            {t('Auth.SingleSignOn.logInWithMicrosoft')}
        </a>

    </div>
}
export default SingleSignOn